import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Program } from '../models';
import { AppState } from '../../../../core/reducers';
import { currentUser } from '../../../../core/auth';
import { environment } from '../../../../../environments/environment';
import { QueryParamsModel, QueryResultsModel } from '../../../../core/_base/crud';

@Injectable({ providedIn: 'root' })
export class ProgramService {
  private companyId;
  private baseUrl = environment.COMPLIANCE_BASE;

  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.store.select(currentUser).subscribe((res) => (this.companyId = res.companyID));
  }

  getProgramPage(query: QueryParamsModel): Observable<QueryResultsModel> {
    const {
      pageSize,
      pageNumber,
      filter: { searchTerm },
      sortField,
      sortOrder,
    } = query;

    const fromString = `page=${pageNumber}&size=${pageSize}&search_term=${searchTerm}&sort=${sortField},${sortOrder}`;
    const params = new HttpParams({ fromString });

    return this.http.get<QueryResultsModel>(
      `${this.baseUrl}/companies/${this.companyId}/programs`,
      { params },
    );
  }

  searchProgram(searchTerm = ''): Observable<QueryResultsModel> {
    const query = new QueryParamsModel({ searchTerm }, 'asc', 'name', 0, 20);

    return this.getProgramPage(query);
  }

  createProgram(program: Program): Observable<HttpResponse<Program>> {
    return this.http.post<Program>(
      `${this.baseUrl}/companies/${this.companyId}/programs`,
      program,
      { observe: 'response' },
    );
  }

  updateProgram(program: Program): Observable<HttpResponse<Program>> {
    return this.http.put<Program>(
      `${this.baseUrl}/companies/${this.companyId}/programs/${program.id}`,
      program,
      { observe: 'response' },
    );
  }

  deleteProgram(programId: number): Observable<HttpResponse<Program>> {
    return this.http.delete<Program>(
      `${this.baseUrl}/companies/${this.companyId}/programs/${programId}`,
      { observe: 'response' },
    );
  }

  addProgramStandards(
    programId: number,
    standardIds: number[],
  ): Observable<HttpResponse<{ standard_ids: number[] }>> {
    return this.http.post<{ standard_ids: number[] }>(
      `${this.baseUrl}/companies/${this.companyId}/programs/${programId}/standards`,
      { standard_ids: standardIds },
      { observe: 'response' },
    );
  }

  deleteProgramStandard(programId: number, standardId: number): Observable<HttpResponse<void>> {
    return this.http.delete<void>(
      `${this.baseUrl}/companies/${this.companyId}/programs/${programId}/standards/${standardId}`,
      { observe: 'response' },
    );
  }
}
